import React from 'react';
import { HyperdbForm } from '../../../../hyperdb';
import Form from '../components/Form';

class CreateForm extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleClickCheckbox = this.handleClickCheckbox.bind(this);
    this.handleChangeSettings = this.handleChangeSettings.bind(this);
  }
  componentDidMount() {
    const defaultSettings = {
      price_ratio: 1,
      receive_property_details: true,
      receive_prices: true,
      receive_conditions: true,
      receive_availability: true,
      send_inquiries: true,
      send_reservations: true,
    };
    this.handleChange('settings', { value: defaultSettings }, true);
  }
  render() {
    return (
      <Form
        objectData={ this.props.objectData }
        onChange={ this.handleChange }
        onClickCheckbox={ this.handleClickCheckbox }
        onChangeSettings={ this.handleChangeSettings }
      />
    );
  }

  handleChange(attributeName, field, noSetDirty = false) {
    let value = field.value;
    if (attributeName === 'type' && !value) value = 'input';
    if (attributeName === 'protocol' && !value) value = 'Domino';
    this.props.api.channel.updateEditedObject({ attributeName, value, noSetDirty });
  }
  handleClickCheckbox(attributeName) {
    const checked = !this.props.objectData[attributeName];
    this.handleChange(attributeName, { value: checked });
  }
  handleChangeSettings(attributeName, field, noSetDirty = false) {
    const settings = { ...this.props.objectData.settings || {} };
    settings[attributeName] = field.value;
    this.handleChange('settings', { value: settings }, noSetDirty);
  }
}

CreateForm.propTypes = {
  api: React.PropTypes.object,
  objectData: React.PropTypes.object,
};

export default HyperdbForm(CreateForm, {
  namespace: 'channel',
  mountedUrl: '/channels',
  titleNew: 'Create new channel',
  afterCreate: (props) => props.api.routing.redirect(props.router, `/channels/${props.savedObject.id}`),
});



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/channel/containers/CreateForm.jsx